import isFunction from 'lodash/isFunction';
import React, { useEffect, useState } from 'react';
import { LearningCenterArticleLink } from '../../learningCenter/LearningCenterArticleLink.component';
import UI from '../../ui';
import Typography from '../../ui/Typography.component';
import Utils from '../../utils';

const { WrappedButton, WrappedButtonType, InlineMessage } = UI;
const {
	Session,
	Communication,
	withLayoutAndModalContexts,
	AccountCaps,
	Util,
} = Utils;

const RefundAssistView = props => {
	const [refundAssistEnabled, setRefundAssistEnabled] = useState(false);
	const [accountCapabilities, setAccountCapabilities] = useState();
	const [userInfoRecieved, setUserInfoRecieved] = useState(false);
	const [disableUpdateButton, setdisableUpdateButton] = useState(false);

	const { refundassistRefundPercent } = Session.getAccountInfo();

	const {
		modalContext: { showError },
	} = props;

	const getUserInfo = async () => {
		const userInfo = await Communication.getUsers();

		setUserInfoRecieved(true);

		if (Communication.isSuccessful(userInfo)) {
			const {
				data: { AccountCapabilities },
			} = userInfo;

			setAccountCapabilities(AccountCapabilities);

			setRefundAssistEnabled(
				Util.hasBitSet(AccountCapabilities, AccountCaps.acRefundAssist)
			);
		}
	};

	const updateAccountCapabilities = async updatedCaps => {
		const capabilitiesResponse =
			await Communication.updateAccountCapabilities(updatedCaps);

		if (Communication.isSuccessful(capabilitiesResponse)) {
			getUserInfo();
		} else {
			showError({ capabilitiesResponse });
		}
	};

	const updateRefundAssist = enable => {
		let updatedCaps;

		setdisableUpdateButton(true);

		if (enable) {
			updatedCaps = Util.setBit(
				accountCapabilities,
				AccountCaps.acRefundAssist
			);
			setdisableUpdateButton(false);
		} else {
			updatedCaps = Util.removeBit(
				accountCapabilities,
				AccountCaps.acRefundAssist
			);
			setdisableUpdateButton(false);
		}

		setAccountCapabilities(updatedCaps);
		updateAccountCapabilities(updatedCaps);
	};

	const onClickDone = () => {
		const { IsInWinClient } = Session.getSettings();
		const { completionCallback } = props;

		if (IsInWinClient === true) {
			window.external.Close();
		}

		if (isFunction(completionCallback)) {
			completionCallback({ close: true });
		}
	};

	useEffect(async () => {
		getUserInfo();
	}, []);

	return (
		<div className="settings-mail-refund-assist-view">
			<div className="settings-body">
				<div className="settings-content-header">
					<p>Refund Assist</p>
				</div>
				{userInfoRecieved &&
					(!refundAssistEnabled ? (
						<div className="p-grid p-nogutter p-dir-col refund-assist-container">
							<div className="p-col-12">
								<Typography.H4>
									Never miss a refund for unused USPS® shipping labels.
								</Typography.H4>
								<Typography.P>
									We believe you could benefit from Refund Assist, which
									identifies your eligible unused USPS® labels and submits
									refund requests on your behalf.
								</Typography.P>
								<Typography.P>
									Labels qualify if printed but not received or scanned by USPS
									within twenty-one (21) days of the print date. You can always
									view eligible labels on your <b>History</b> page.
								</Typography.P>
								<Typography.P>
									After labels are scheduled for a refund, you have five days to
									exclude any you don't want refunded.Stamps.com will submit
									these requests to USPS®, which typically processes them within
									1-4 weeks. Once processed, you'll receive a credit to your
									account balance for {refundassistRefundPercent}% of the
									USPS-approved refund amount.
								</Typography.P>
								<Typography.P className="bold">
									Enable Refund Assist now to take advantage of this convenient
									money-saving feature.
								</Typography.P>
							</div>
							<div className="settings-content-footer">
								<LearningCenterArticleLink
									linkText="Learn more"
									stamps="27608643172635"
								/>
								<WrappedButton
									className="refund-enable-button"
									label="Enable Refund Assist"
									type="button"
									disabled={disableUpdateButton}
									onClick={() => {
										updateRefundAssist(true);
									}}
									dataqa="refund-assist-enable-now"
								/>
							</div>
						</div>
					) : (
						<div className="p-grid p-dir-col refund-assist-container">
							<div className="p-col-12">
								<Typography.H4>
									Stamps.com now reviews unused USPS® labels and submits
									eligible refund requests on your behalf.
								</Typography.H4>
								<Typography.P>
									Labels qualify if they haven't entered the mail stream within
									21 days of their print date. You can always view eligible
									labels on your <b>History</b> page.
								</Typography.P>
								<Typography.P>
									After labels are scheduled for a refund, you have five days to
									exclude any you don't want refunded.
								</Typography.P>
								<Typography.P>
									Stamps.com will submit these requests to USPS®, which
									typically processes them within 1-4 weeks. Once processed,
									you'll receive a credit to your account balance for{' '}
									{refundassistRefundPercent}% of the USPS-approved refund
									amount.
								</Typography.P>
								<Typography.P>
									To check the credited amount for any label, navigate to the{' '}
									<b>History</b> page and open the label details.
								</Typography.P>
								<InlineMessage
									type="information"
									header="USPS Fraud Disclaimer"
									className="refund-assist-disclaimer"
									text={
										<>
											<span className="disclaimer-paragraph">
												The filing of false, fictitious, or fraudulent refund
												requests may be punishable under the criminal laws of
												the United States. 18 U.S.C. §1001.
											</span>
											By opting into Refund Assist, you certify that the labels
											submitted for refund were unused and have been destroyed.
											You will be charged the cost of postage and a penalty for
											any refunded labels that are found to be used.
										</>
									}
									dataqa="usps-fraud-disclaimer"
								/>
							</div>
							<div className="settings-content-footer">
								<LearningCenterArticleLink
									linkText="Learn more about Refund Assist"
									stamps="27608643172635"
								/>
								<div className="p-col-12">
									<WrappedButton
										label="Disable Refund Assist"
										buttonType={WrappedButtonType.Secondary}
										disabled={disableUpdateButton}
										onClick={() => updateRefundAssist(false)}
										dataqa="refund-assist-disable"
									/>
									<WrappedButton
										className="settings-button"
										label="Done"
										type="button"
										onClick={onClickDone}
										dataqa="savesettings"
									/>
								</div>
							</div>
						</div>
					))}
			</div>
		</div>
	);
};

export default withLayoutAndModalContexts(RefundAssistView);
